import { TopbarLogo } from './styles'

export const Logotipo = ({ width }) => {
  return (
    <TopbarLogo to="/">
      <img
        src="/logo-jah-retina.png"
        alt="logotipo JAH Açai"
        style={{ width }}
      />
    </TopbarLogo>
  )
}
